export default "__VITE_ASSET__1tVkCz0n__"